import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';

import FAQ from './FAQ';
import styles from './style';
import Account from './Account';
import Link from '../../atomic/Link';
import Badge from '../../atomic/Badge';
import AppBar from '../../atomic/AppBar';
import PropertySelect from './PropertySelect';
import Container from '../../layouts/Container';
import IconButton from '../../atomic/IconButton';
import useHeaderSnackbar from '../../../hooks/useHeaderSnackbar';
import NotificationIcon from '../../../assets/icons/Notification';
import useDashboardLinkPrefix from '../../../hooks/useDashboardLinkPrefix';
import { sGetUnseenNotifications } from '../../../store/reducers/notifications';

const Header = ({
  classes,
  className,
  unseenNotifications,
  isFromPersonal,
}) => {
  const { snackbarHeight } = useHeaderSnackbar();
  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const notificationsLink = `${dashboardLinkPrefix}/notifications`;

  return (
    <AppBar
      elevation={1}
      color="inherit"
      position="sticky"
      className={clsx(className, classes.root)}
      style={{ top: snackbarHeight, zIndex: 1101 }}
    >
      <Container>
        <Toolbar disableGutters>
          {!isFromPersonal && <PropertySelect />}

          <div className={classes.grow} />
          {!isFromPersonal && (
            <div>
              <Link inheritColor to={notificationsLink}>
                <IconButton color="primary">
                  <Badge
                    classes={{ badge: classes.badge }}
                    badgeContent={unseenNotifications.length}
                  >
                    <NotificationIcon className={classes.notificationIcon} />
                  </Badge>
                </IconButton>
              </Link>

              <FAQ />
            </div>
          )}

          <div>
            <Account isFromPersonal={isFromPersonal} />
          </div>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

const mapStateToProps = (state) => ({
  unseenNotifications: sGetUnseenNotifications(state),
});

export default connect(mapStateToProps)(withStyles(styles)(Header));
